export const PERSISTED_AT_SET_VALUE = 'easiplusFuneralPlan/setValue/persistedAt';

export const setPersistedAtValue = () => ({ type: PERSISTED_AT_SET_VALUE });
